import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import { production_credentials } from './production_credentials';
import { development_credentials } from './development_credentials';
import { connectFunctionsEmulator } from "firebase/functions";
console.log(process.env.NODE_ENV);
const credentials = process.env.NODE_ENV === 'development' ? 
development_credentials
: production_credentials;
const firebaseApp = firebase.initializeApp(credentials);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const cloudFunctions = firebase.functions();

if(process.env.NODE_ENV === 'development')
    connectFunctionsEmulator(cloudFunctions, "localhost", 5001);

export { auth, db, cloudFunctions };